/**
 *  All api related to addresses
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchCountries({
  params,
  ...otherOptions
}) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCountries',
    () => source.cancel('fetchCountries: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'addresses/countries',
      method: 'get',
      params,
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      countries: data.countries
    }))
}

// states_cities_districts
export function fetchStatesCitiesDistricts({
  country,
  params = {},
  ...otherOptions
}) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchStatesCitiesDistricts',
    () => source.cancel('fetchStatesCitiesDistricts: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `addresses/countries/${country}/states_cities_districts`,
      method: 'get',
      params,
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      states: data.states
    }))
}

// streets
export function fetchStreet({
  country,
  state,
  city,
  district,
  params = {},
  ...otherOptions
}) {
  // handling converting empty string when the option is `none` when creating the address
  const urlData = {
    country,
    state: _.isEmpty(state) ? 'none' : state,
    city: _.isEmpty(city) ? 'none' : city,
    district: _.isEmpty(district) ? 'none' : district,
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchStreet',
    () => source.cancel('fetchStreet: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `addresses/countries/${urlData.country}/states_cities_districts/${urlData.state}/${urlData.city}/${urlData.district}/streets`,
      method: 'get',
      params,
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      streetLine1: data.streetLine1
    }))
}

// zip
export function fetchZip({
  countryCode,
  ...params
}) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchZip',
    () => source.cancel('fetchZip: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `addresses/countries/${countryCode}/resolve/zip`,
      method: 'get',
      params,
      cancelToken: source.token,
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      zip: data.zip
    }))
}
